import { createTranslations } from '@npco/utils-translations'

export const categoryOrContactDropdownTranslations = createTranslations({
  category: 'Category',
  contact: 'Contact',
  title: 'Transactions by',
})
